import en from './en';
import fa from './fa';

const messages = {
    en: en,
    fa: fa
};

export default messages;
